import { OD_TASK_ADDED, OD_TASK_SET, OD_TASK_EDITED, OD_TASK_DELETED } from 'src/app/redux/redux-types';
import { reduxODTaskTypes } from 'src/types';

export const odTaskDefaultState: reduxODTaskTypes.StateType = {
  taskList: [],
};

export const odTaskReducer = (
  state = odTaskDefaultState,
  action: reduxODTaskTypes.ActionType,
): reduxODTaskTypes.StateType => {
  switch (action.type) {
    case OD_TASK_SET:
      return {
        ...state,
        taskList: action.payload,
      };
    case OD_TASK_ADDED:
      const exists = state.taskList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        taskList: [...state.taskList, action.payload],
      };
    case OD_TASK_EDITED:
      state.taskList = state.taskList.map((task) => (task.id === action.payload.id ? action.payload : task));
      return {
        ...state,
      };
    case OD_TASK_DELETED:
      state.taskList = state.taskList.filter((task) => task.id !== action.payload);
      return {
        ...state,
      };
    default:
      return state;
  }
};
